module.exports = __webpack_public_path__ + "img/dhl.eb28f281.png";